import { useState } from 'react'
import { Box, Button, Container, Grid, Link, TextField, Typography } from '@mui/material'
import React from 'react'
import { useNavigate } from "react-router-dom"
import { useUserContext } from 'strview-common'

const ForgotPasswordStepOneForm = () => {
  const {  forgotPassword } = useUserContext()
  const navigate = useNavigate()
  const [errorMessage, setErrorMessage] = useState("")

  const handleSubmit = async (event) => {
    event.preventDefault()
    const formData = new FormData(event.currentTarget)
    const data = {
      email: formData.get("email"),
    }

    const forgotPasswordResult = await forgotPassword(data)
    if (forgotPasswordResult.success) {
      navigate("/forgot-password-step-two")
    } else {
      setErrorMessage(forgotPasswordResult.errorMessage)
    }
  }

  return (
    <Container component="main" maxWidth="xs">
      <Box
        sx={{
          marginTop: 8,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Typography component="h1" variant="h5">
          Forgot Password
        </Typography>
        <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
          <TextField
            margin="normal"
            required
            fullWidth
            id="email"
            label="Email Address"
            name="email"
            autoComplete="email"
            autoFocus
          />
          <Typography sx={{ "color": "red" }} >
            {errorMessage}
          </Typography>
          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
          >
            Submit
          </Button>
          <Grid container>
            <Grid item xs>
              <Link href="/login" variant="body2">
                Login
              </Link>
            </Grid>

          </Grid>
        </Box>
      </Box>
    </Container>
  )
}

export default ForgotPasswordStepOneForm